import React from 'react';
import styles from './details-sidebar.module.scss';
import {numberFormat} from "@/app/number";
import ShareButton from "@/components/global/share-button";

type Props = {
  artist: IArtistDetails | null | undefined
};

const ArtistDetailsSidebar: React.FC<Props> = ({ artist }) => {
  return (
    <div className={styles.artistDetailsSidebar}>
      <div className={styles.detailSection}>
        <div className={styles.imageContainer}>
          {artist ? (
              <img src={artist.avatar || '//placehold.it/400x400'} alt={artist.name || 'در حال بارگزاری...'} />
          ) : (
              <div className={styles.loadingImage} />
          )}
        </div>
        <div className={styles.title}>
          <h3>{artist?.name || 'در حال بارگزاری...'}</h3>
          <div className={styles.buttonContainer}>
            <ShareButton />
          </div>
        </div>
      </div>
      <div className={styles.detailSection}>
        <h5>اطلاعات کلی</h5>
        <div className={styles.infoContainer}>
          <div className={styles.infoItem}>
            <strong>تعداد بازدید</strong>
            <span>
              {numberFormat(artist?.views || 0)}
            </span>
          </div>
          <div className={styles.infoItem}>
            <strong>تعداد پست ها</strong>
            <span>
              {numberFormat(artist?.post_count || 0)}
            </span>
          </div>
          <div className={styles.infoItem}>
            <strong>تاریخ عضویت</strong>
            <span>
              {artist?.register_date}
            </span>
          </div>
          <div className={styles.descriptionItem}>
            <strong>بیوگرافی</strong>
            <p>
              {artist?.bio}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArtistDetailsSidebar;
